import { render, staticRenderFns } from "./UnmatchedContactList.vue?vue&type=template&id=594da6a8"
import script from "./UnmatchedContactList.vue?vue&type=script&lang=js"
export * from "./UnmatchedContactList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports